<template>
  <div class="col-12 q-mb-lg">
    <q-card
      class="post-card border-radius-20 cursor-pointer full-height q-pb-md overflow-hidden"
      flat
      tag="a"
      :href="post.publicUrl"
    >
      <img
        :src="cover"
        :alt="post.metaFields.coverImageAlt"
        loading="lazy"
        :width="width"
        :height="height"
        class="post-card-image q-mb-md"
      >

      <q-card-section class="q-pb-none q-px-lg">
        <div class="post-date fs-12 q-mb-sm">
          {{ dayjs.unix(post.createdAt.timestamp).format('DD.MM.YYYY') }}
          {{ dayjs.unix(post.createdAt.timestamp).format('HH:mm') }}
        </div>
        <div class="post-title fs-16 q-mb-sm">
          {{ post.title }}
        </div>
      </q-card-section>

      <q-card-section class="post-content q-pt-sm q-px-lg">
        <div v-html="description" />
      </q-card-section>
    </q-card>
  </div>
</template>

<script setup>
import dayjs from 'dayjs';
import { computed } from 'vue';
import getThumb from 'src/helpers/getThumb';
import { useQuasar } from 'quasar';

const $q = useQuasar();

const props = defineProps({
  containerClass: {
    type: String,
    default: 'q-pa-sm',
  },
  post: {
    type: Object,
    default: () => ({}),
  },
});

const width = $q.platform.is.mobile ? 330 : 500;
const height = $q.platform.is.mobile ? 240 : 250;

const cover = computed(() => {
  if (!props.post.coverImageGuid?.url) {
    return '/empty-blog-cover.png';
  }

  return getThumb(props.post.coverImageGuid?.url, width, height);
});
const description = computed(() => props.post.metaFields.metaDescription || props.post.excerptContent);
</script>

<style lang="scss" scoped>
.post-card {
  display: block;
  background: var(--blog-card-color, #fff);
  color: inherit;
  text-decoration: inherit;
}
.post-date,
.post-content {
  opacity: 0.5;
}
.post-date {
  line-height: 12px;
}
.post-title {
  overflow: hidden;
  line-height: 22px;
  height: 44px;
}
.post-content {
  line-height: 20px;
}
.post-card-image {
  object-fit: cover;
}
</style>
